import React from "react";
import "./Home.css";

const leaders = [
  {
    name: "देवेंद्र फडणवीस",
    post: "माननीय मुख्यमंत्री",
    img: "/images/devendra-fadnavis.jpg",
  },
  {
    name: "एकनाथ शिंदे",
    post: "माननीय उपमुख्यमंत्री",
    img: "/images/eknath-shinde.jpg",
  },
  {
    name: "सुनेत्रा अजित पवार",
    post: "माननीय उपमुख्यमंत्री",
    img: "/images/sunetra-pawar.jpg",
  },
  {
    name: "योगेश कदम",
    post: "माननीय राज्यमंत्री, ग्रामविकास व पंचायतराज विभाग",
    img: "/images/yogesh-kadam.jpg",
  },
  {
    name: "जयकुमार गोरे",
    post: "माननीय मंत्री, ग्रामविकास व पंचायतराज विभाग",
    img: "/images/jaykumar-gore.jpg",
  },
];

const members = [
  {
    name: "सौ. यशोदा वामनराव पाटील",
    post: "प्रशासक",
    img: "/images/sarpanch.jpeg",
  },
  {
    name: "श्री राजू गोवर्धन शेंदरे",
    post: "ग्रामपंचायत अधिकारी",
    phone: "9764572954",
    img: "/images/sachiv.jpeg",
  },
];

const Home = () => {
  return (
    <div id="container">
      <main>
        {/* Hero Banner */}
        <div className="hero-banner">
          <img
            src="/images/photo45.jpeg"
            alt="ग्रामपंचायत भालेवाडी"
          />
        </div>

        {/* Maharashtra Leaders */}
        <section className="leaders-section">
          <h2>महाराष्ट्र शासन मान्यवर</h2>

          <div className="leaders-grid">
            {leaders.map((leader, index) => (
              <div className="leader-card" key={index}>
                <img src={leader.img} alt={leader.name} />
                <h3>{leader.name}</h3>
                <p>{leader.post}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Gram Panchayat Members */}
        <section className="members-section">
          <h3 className="style2">ग्रामपंचायत पदाधिकारी</h3>

          <div className="members-grid">
            {members.map((member, index) => (
              <div className="member-card" key={index}>
                <img src={member.img} alt={member.name} />

                <h3>{member.name}</h3>

                <p>{member.post}</p>

                {member.phone && (
                  <p className="phone">
                    📞 संपर्क: {member.phone}
                  </p>
                )}
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;